// AC GUIDES — the blog (Oct 2026).
//
// Simple answers to the AC questions people search for most, each with a
// short animation and every fact linked to Daikin, the Government of India or
// our own service team. Hub at /blog, one page per guide at /blog/<slug>.
//
// Order is the order Saheb chose to publish them in (Oct 2026). A guide with
// `live: false` shows on the hub and under each guide as "Coming next", with
// no link, so nobody lands on a page that does not exist yet. When a guide
// goes live, give it a page and a route and flip `live`.
//
// `icon` picks the card's icon from GuideIcon in components/guide/GuideParts.jsx
// (inverter, meter, star, thermometer, vrv, service, rupee, ruler, chip,
// calculator); anything else shows a book. `minutes` and `tools` show on the
// hub card.
//
// No imports: scripts/prerender.js loads this file by stripping `export`.

export const BLOG_SLUG = 'blog';

export const BLOG_SEO = {
  title: 'AC Guides: Simple Answers to Common AC Questions | Citi Cool',
  meta: 'Inverter or non-inverter, units per hour, 3 Star or 5 Star, the best temperature, installation cost: simple answers from Delhi\'s Daikin dealer since 2003.',
  h1: 'AC Guides',
  intro: 'Simple answers to the questions people ask before buying an AC. Each guide gives the answer first, shows it with a short animation, and links every fact to Daikin, the Government of India or our own team.',
};

export const GUIDES = [
  {
    slug: 'inverter-vs-non-inverter-ac',
    title: 'Inverter vs non-inverter AC: which one should you buy?',
    blurb: 'Inverter for a bedroom used 6+ hours a day. Non-inverter for short use, a top floor or a hall.',
    icon: 'inverter',
    minutes: 4,
    tools: 1,
    live: true,
  },
  {
    slug: 'ac-power-consumption-units-per-hour',
    title: 'How many units does a 1.5 ton AC use in an hour?',
    blurb: 'About half a unit on the label. Two to three times that on a top floor.',
    icon: 'meter',
    minutes: 4,
    tools: 2,
    live: true,
  },
  {
    slug: 'difference-between-inverter-and-non-inverter-ac',
    title: 'What is the difference between an inverter and a non-inverter AC?',
    blurb: 'One is fully on or off. The other slows down. Watch both work.',
    icon: 'chip',
    minutes: 4,
    tools: 1,
    live: true,
  },
  {
    slug: '3-star-vs-5-star-ac',
    title: '3 Star vs 5 Star AC: is a 5 Star worth it?',
    blurb: 'A 5 Star for long hours. A 3 Star for nights and short use.',
    icon: 'star',
    minutes: 4,
    tools: 1,
    live: true,
  },
  {
    slug: 'ideal-ac-temperature',
    title: 'What is the best temperature to set your AC?',
    blurb: '24°C, and 26°C at night. Never 18°C.',
    icon: 'thermometer',
    minutes: 4,
    tools: 2,
    live: true,
  },
  {
    slug: 'ac-installation-cost',
    title: 'How much does AC installation cost in Delhi?',
    blurb: 'About ₹2,700 to fit a split AC, plus copper pipe by the metre. Our rate card, item by item.',
    icon: 'rupee',
    minutes: 4,
    tools: 2,
    live: true,
  },
  {
    slug: 'vrv-vs-split-ac',
    title: 'VRV or split AC: which is better for your home?',
    blurb: 'VRV when you have no space for outdoor units. It costs more to buy and less to run.',
    icon: 'vrv',
    minutes: 4,
    tools: 2,
    live: true,
  },
  {
    slug: 'what-size-ac-do-i-need',
    title: 'What size AC do I need for my room?',
    blurb: 'A 1.5 ton for most bedrooms. A 5 Star or a bigger AC on a top floor.',
    icon: 'ruler',
    minutes: 4,
    tools: 1,
    live: true,
  },
  {
    slug: 'hot-and-cold-ac',
    title: 'Hot and cold AC: is it worth it in Delhi?',
    blurb: 'Yes, for a bedroom you use in winter. One AC all year, and no fumes.',
    icon: 'thermometer',
    minutes: 4,
    tools: 1,
    live: true,
  },
  {
    title: 'Daikin AC error codes: what they mean',
    blurb: 'What the code on your remote is telling you.',
    live: false,
  },
  {
    title: 'What is ISEER? The star label number explained',
    blurb: 'The number that tells you how much an AC costs to run.',
    live: false,
  },
  {
    title: 'Cassette AC or split AC?',
    blurb: 'Which one suits your room and your ceiling.',
    live: false,
  },
];

// The AC calculator sits beside the guides as a live tool.
export const GUIDE_TOOLS = [
  {
    href: '/ac-calculator',
    title: 'Which ton AC does my room need?',
    blurb: "Sized for your city's hottest day, with the right AC from stock.",
  },
];

export const guidePath = (g) => `/${BLOG_SLUG}/${g.slug}`;
